import React from 'react';
import styles from './style.css';

const BYOPLegal = () => {
  return (
    <div className="legal-container">
      <div className="legal">
        <p>
          <strong>
            Current performance may be lower or higher than the quoted past
            performance, which cannot guarantee future results. Share price,
            principal value, and return will vary and you may have a gain or
            loss when you sell your shares.
          </strong>{' '}
          Average annual total return figures include changes in principal
          value, reinvested dividends, and capital gain distributions.
        </p>
        <p>
          <strong>
            Consider the investment objectives, risks, and charges and expenses
            carefully before investing. For a prospectus or, if available, a
            summary prospectus containing this and other information,visit
            troweprice.com. Read it carefully.
          </strong>
        </p>
        <p>
          * The T. Rowe Price Funds-I Class share the portfolio of an existing
          fund (the original share class of the fund is referred to as the
          &quot;investor class&quot;). The total return figures for I Class
          shares have been calculated using the performance data of the investor
          class up to the inception date of the I Class (shown above) and the
          actual performance results of the I Class since that date. Because the
          I Classes are expected to have lower expenses than the Investor
          Classes, the I Class performance, had it existed over the periods
          shown, would have been higher.
        </p>
        <p>
          ** This chart displays relative risk of each U.S. mutual fund listed
          using standard deviation of returns. Standard deviation measures
          historical volatility of returns. Higher standard deviation implies
          greater volatility. We use ten risk categories. Each fund’s specific
          risk category is displayed. Funds in the bottom three categories
          (0-4.5%) are characterized as lower risk, funds in the middle four
          categories (3.5-16%) are characterized as moderate risk, and funds in
          the top three categories (≥ 15%) are described as higher risk.
        </p>
        <p>
          Methodology: We evaluate the standard deviation and its resulting
          placement within a specific risk/return category on an annual basis. A
          fund is generally placed in a risk/return category based on the
          10-year standard deviation of its performance. If a fund is less than
          10 years old, the actual fund performance history is supplemented with
          the primary prospectus benchmark history to obtain a full 10-year
          history, or longest time period available up to 10 years. For an Asset
          Allocation fund with less than 10 years of performance history,
          sub-strategy returns are used. When a sub-strategy is less than 10
          years old, the actual sub-strategy performance history is supplemented
          with benchmark history to obtain a full 10-year history, or longest
          time period available up to 10 years.
        </p>
        <p>
          Risk return categories overlap; a fund with a standard deviation in
          the overlap between two categories, denoted by a plus (+), is
          displayed in the risk category that is better aligned with anticipated
          return characteristics an investor may experience going forward at the
          discretion of T Rowe Price.{' '}
        </p>
        <p>
          When a fund has a cash-like benchmark, denoted by a double plus (++),
          its standard deviation is estimated using only available fund returns.
          If the fund is less than 10 years old, benchmark returns are not used
          to obtain a full 10-year history because they would artificially
          suppress the volatility estimate.
        </p>
        <p>
          All investments are subject to market risk, including the possible
          loss of principal. Standard deviation of returns, a measure of price
          volatility, is one measure of risk. Please consult the funds’
          prospectuses for a more complete discussion of the funds’ risks.
        </p>
        <p>
          *** The T. Rowe Price US High Yield Fund (&quot;Fund&quot;) commenced
          operations on May 19, 2017. At that time, the Fund received all of the
          assets and liabilities of the Henderson High Yield Opportunities Fund
          (the &quot;Predecessor Fund&quot;) and adopted its performance and
          accounting history. The Fund and the Predecessor Fund have
          substantially similar investment objectives and strategies. The
          Predecessor Fund was managed by the same portfolio manager as the
          Fund.
        </p>
        <p>
          ‡ Retail Funds:{' '}
          <strong>
            You could lose money by investing in the Fund. Although the Fund
            seeks to preserve the value of your investment at $1.00 per share,
            it cannot guarantee it will do so. The Fund may impose a fee upon
            sale of your shares. An investment in the Fund is not a bank account
            and is not insured or guaranteed by the Federal Deposit Insurance
            Corporation or any other government agency. T. Rowe Price
            Associates, Inc. is not required to reimburse the Fund for losses,
            and you should not expect that T. Rowe Price Associates, Inc. will
            provide financial support to the Fund at any time, including during
            periods of market stress.
          </strong>
        </p>
        <p>
          ‡‡ Government Funds:{' '}
          <strong>
            You could lose money by investing in the Fund. Although the Fund
            seeks to preserve the value of your investment at $1.00 per share,
            it cannot guarantee it will do so. An investment in the Fund is not
            a bank account and is not insured or guaranteed by the Federal
            Deposit Insurance Corporation or any other government agency. T.
            Rowe Price Associates, Inc. is not required to reimburse the Fund
            for losses, and you should not expect that T. Rowe Price Associates,
            Inc. will provide financial support to the Fund at any time,
            including during periods of market stress.
          </strong>
        </p>
        <p>
          †{' '}
          <strong>
            Investors should note that the fund’s short-term performance is
            highly unusual and unlikely to be sustained.
          </strong>
        </p>
        <p>
          T. Rowe Price mutual funds are distributed by T. Rowe Price Investment
          Services, Inc.
        </p>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default BYOPLegal;
